import { useEffect, useState } from 'react';
import MultiSelect from './MultiSelect';
import { AtendentesService } from '../../modules/atendentes/Service';
import AvatarUser from '../AvatarUser';
import { useAuthContext } from '../../contexts/AuthContext';
import { useEstabsContext } from '../../contexts/EstabsContext';

const service = new AtendentesService();

export default function SelectAtendentes({
                                             name,
                                             value,
                                             setValue,
                                             multiple = true,
                                             label,
                                             placeholder,
                                             size,
                                             borderless = false,
                                             menuOverlay = false,
                                             searchable = true,
                                             autoSelectFirstOption = false,
                                         }: {
    name: string;
    value: string[] | string;
    setValue: (value: any) => void;
    multiple?: boolean;
    label?: string;
    placeholder?: string;
    size?: string;
    borderless?: boolean;
    menuOverlay?: boolean;
    searchable?: boolean;
    autoSelectFirstOption?: boolean;
}) {
    const { user } = useAuthContext();
    const { estabSession } = useEstabsContext();
    const [loading, setLoading] = useState(true);
    const [options, setOptions] = useState<{ value: string; label: string; photoURL?: string }[]>([]);

    useEffect(() => {
        let isMounted = true;

        const loadAtendentes = async () => {
            setLoading(true);
            const response = await service.getAll();
            const atendentes: any[] = response?.data?.data || [];
            const filteredAtendentes =
                user?.admin && !estabSession?.allowAttendantsSeeOthersInSelect
                    ? atendentes.filter((e: any) => e.uid === user.uid || e.type !== 'admin')
                    : atendentes;

            if (!isMounted) {
                return;
            }

            setOptions(
                filteredAtendentes.map((e: any) => ({
                    value: e.uid,
                    label: e.displayName,
                    photoURL: e.photoURL,
                })),
            );
            setLoading(false);
        };

        loadAtendentes();

        return () => {
            isMounted = false;
        };
    }, [user?.admin, user?.worker, user?.uid, estabSession?.allowAttendantsSeeOthersInSelect]);

    useEffect(() => {
        if (!autoSelectFirstOption || multiple || loading || !options.length) {
            return;
        }

        const currentValue = typeof value === 'string' ? value : '';
        const hasCurrentValue = !!currentValue && options.some((option) => option.value === currentValue);

        if (!hasCurrentValue) {
            setValue(options[0].value);
        }
    }, [autoSelectFirstOption, loading, multiple, options, setValue, value]);

    return (
        <MultiSelect
            options={options}
            loading={loading}
            value={value}
            onChange={setValue}
            placeholder={placeholder || 'Selecione os atendentes'}
            label={label}
            name={name}
            multiple={multiple}
            borderless={borderless}
            menuOverlay={menuOverlay}
            searchable={searchable}
            formatOptionLabel={(option, meta) =>
                meta.context === 'menu' ? (
                    <div className="flex items-center gap-3 px-3 py-2.5">
                        <AvatarUser size={size} name={option.label} photoURL={option.photoURL} />
                        <div className="min-w-0">
                            <div className="truncate text-sm font-medium text-base-content">{option.label}</div>
                            <div className="text-[11px] uppercase tracking-wide text-base-content/45">Atendente</div>
                        </div>
                    </div>
                ) : (
                    <div className="flex items-center gap-2 py-0.5">
                        <AvatarUser size={size} name={option.label} photoURL={option.photoURL} />
                        <span className="truncate">{option.label}</span>
                    </div>
                )
            }
        />
    );
}
